import React, { useState } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import dayjs from 'dayjs';
import { format } from '../../../services';


// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ColumnChartByYear = ({dataInput}) => {
  

  // Chart data
  const data = {
    labels: dataInput.map((val) => val.month), // Use month labels (e.g., 'JAN', 'FEB', ...)
    datasets: [
      {
        label: 'Aggregate charges',
        data: dataInput.map((val) => !!val.billingTotal ? val.billingTotal : 0),
        backgroundColor: 'rgba(34, 202, 236, 0.5)',
        borderColor: 'rgba(34, 202, 236, 1)',
        borderWidth: 1,
        borderRadius: 10, // Rounded corners
        barThickness: 30, // Adjust bar width
      },
    ],
  };

  // Chart configuration
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Remove the legend
      },
      tooltip: {
        enabled: true, // Show tooltips on hover
        callbacks: {
          label: (tooltipItem) => {
            // Format the tooltip value as dollars
            return `$${format.numberWithCommas(tooltipItem.raw, '', '')}`;
          },
        },
      },
      title: {
        display: false,
      },
    },
    layout: {
      padding: {
        top: 20, // Extra space to prevent text overlap
      },
    },
    scales: {
      x: {
        title: {
          display: false,
        },
        grid: {
          display: false, // Remove grid lines
        },
      },
      y: {
        display: false, // Remove the Y-axis
      },
    },
  };

  // Add a plugin to display values on top of the bars in dollars
  const valuePlugin = {
    id: 'valuePlugin',
    afterDatasetsDraw: (chart) => {
      const { ctx } = chart;
      chart.data.datasets.forEach((dataset, i) => {
        const meta = chart.getDatasetMeta(i);
        meta.data.forEach((bar, index) => {
          const value = dataset.data[index];
          ctx.fillStyle = '#000';
          ctx.font = '12px Arial';
          ctx.textAlign = 'center';
          // Add a dollar sign to the value displayed above the bar
          ctx.fillText(`$${format.numberWithCommas(value, '', '')}`, bar.x, bar.y - 5); 
        });
      });
    },
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', width: '100%' }}>
   
      {/* Chart */}
      <div style={{ height: '100%', width: '100%' }}>
        <Bar data={data} options={options} plugins={[valuePlugin]} />
      </div>
    </div>
  );
};

export default ColumnChartByYear;
